import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { PaymentController } from '../../controllers';
import { Spinner, Table, Card, Grid } from '../reusable';
import {
  getActivePatients,
  initialDate,
  lastDate,
  subscriptionTableHeaeder
} from '../../utils/Utils';
import { StyledClientes, StyledClientsTable } from './Styles';
import { RouterActions } from '../../redux/actions';

const Clients = props => {
  const { saveHistoryOnRedux, setCurrentNav, history } = props;
  const { profile, subscriptions, activeSubscriptions } = props;
  const { getSubscriptions, getInvoices } = props;

  const [isFetching, setFetching] = useState(true);

  const fetching = async () => {
    try {
      setFetching(true);

      saveHistoryOnRedux(history);
      setCurrentNav('Clientes');

      await getSubscriptions(profile.id, initialDate, lastDate);
      await getInvoices(profile.id, initialDate, lastDate);

      setFetching(false);
    } catch (err) {
      console.log('Error no fetching data', err);
    }
  };

  useEffect(() => {
    fetching();
  }, []);

  return !isFetching ? (
    <StyledClientes>
      <Grid rows={1} columns={2}>
        <Card title={'Pacientes Ativos'} value={activeSubscriptions} tip />
      </Grid>

      <StyledClientsTable>
        <Table headers={subscriptionTableHeaeder} data={subscriptions} />
      </StyledClientsTable>
    </StyledClientes>
  ) : (
    <Spinner />
  );
};

const mapStateToProps = state => {
  const {
    user: { profile },
    payment: {
      subscriptionsInfo: { subscriptions, activeSubscriptions }
    }
  } = state;

  return { profile, subscriptions, activeSubscriptions };
};

const mapDispatchToProps = dispatch => {
  return {
    getSubscriptions: (therapistId, initialDate, finalDate) =>
      PaymentController.fetchAndSaveSubscriptions(therapistId, initialDate, finalDate)(dispatch),
    getInvoices: (therapistId, initialDate, finalDate) =>
      PaymentController.fetchAndSaveAppointmentsInfo(therapistId, initialDate, finalDate)(dispatch),
    saveAmount: ammount => dispatch(PaymentController.saveAmount(ammount)),
    setCurrentNav: current => dispatch(RouterActions.setCurrentRoute(current)),
    saveHistoryOnRedux: history => dispatch(RouterActions.saveHistory(history))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Clients));
